import { useMemo } from "react";
import { PaginationState, SortingState } from "@tanstack/react-table";
import { DataTable } from "@/components/ui/customs/data-table/data-table";
import { GetAllExpeditionBoResponseDtoExpedition } from "@/types/api/api-types";
import { ActionDataBo } from "@/types/tableAction";
import { useGetCustoms } from "@/api/customs.api";
import {
  finalizedAtColumn,
  pickupDateColumn,
  identifierColumn,
  trackingColumn,
  clientColumn,
  clientDestColumn,
  countryColumn,
  btlsVolColumn,
  incotermColumn,
  deliveryStatusBadgeColumn,
  deliveryDateColumn,
  envoiColumn,
  dispatchStatusColumn,
  expeditionRowClassname,
} from "@/components/backOffice/shared/expeditionColumns";

type Props = {
  data: GetAllExpeditionBoResponseDtoExpedition[];
  rowCount: number;
  pagination: PaginationState;
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>;
  sorting: SortingState;
  setSorting: React.Dispatch<React.SetStateAction<SortingState>>;
  setActionData: (actionData: ActionDataBo) => void;
  isLoading?: boolean;
};

export const DeliveredExpeditionsTable = ({
  data,
  rowCount,
  pagination,
  setPagination,
  sorting,
  setSorting,
  setActionData,
  isLoading,
}: Props) => {
  const { data: customs = [] } = useGetCustoms();
  const columns = useMemo(
    () => [
      finalizedAtColumn(setActionData),
      identifierColumn(setActionData, { hideDraft: true }),
      envoiColumn(),
      trackingColumn(),
      deliveryStatusBadgeColumn(),
      clientColumn(),
      clientDestColumn(),
      countryColumn(customs),
      btlsVolColumn(),
      incotermColumn(),
      pickupDateColumn(),
      deliveryDateColumn(),
      dispatchStatusColumn(),
    ],
    [setActionData, customs],
  );

  return (
    <DataTable
      data={data}
      columns={columns}
      pagination={pagination}
      setPagination={setPagination}
      sorting={sorting}
      setSorting={setSorting}
      rowCount={rowCount}
      autoResetPageIndex={false}
      isLoading={isLoading}
      skeletonRowClassName="h-18"
      rowClassname={(row) => expeditionRowClassname(row, "h-18")}
      headerClassName="bg-gray-300"
      headCellClassName="h-12 uppercase text-xs font-semibold tracking-wide text-gray-800 py-2 px-3"
      onRowClick={(row) => setActionData({ expedition: row, action: "DETAIL" })}
    />
  );
};
